import { connect } from 'react-redux';
import {
  resetAddressError,
  resolveLocationFromZipCode,
  updateShippingAddress,
  validateShippingAddress,
  updateCustomerProfile,
} from '../../reducers/actions';
import Form from './ShippingAddressForm';
import getErrorMessage from '../../../lib/utils/getErrorMessage';
import { getAnnualIncomeFeatureVariantFromWallet } from '../../../lib/utils/enrollmentFeature';

const mapStateToProps = ({ auth, geo, progress, shippingAddress, wallet, profile }) => ({
  annualIncomeInputType: getAnnualIncomeFeatureVariantFromWallet(wallet),
  address: wallet?.status?.shipping_address,
  defaultPostalCode: progress?.postal,
  email: auth.email || progress.email,
  error: shippingAddress?.error || getErrorMessage(profile.licenseError),
  errorFetchingLocationInfo: geo.error,
  firstName: wallet.status?.name?.first_name,
  isFetchingLocationInfo: geo.isFetching,
  isLoggedIn: !!auth.account_id,
  isUpdating: !!shippingAddress?.isUpdating || profile.isSavingLicense,
  isValidating: shippingAddress?.isValidating,
  lastName: wallet.status?.name?.last_name,
  locationInfo: geo.location,
  result: shippingAddress?.result,
});

const mapDispatchToProps = dispatch => ({
  fetchLocationInfo: zipCode => dispatch(resolveLocationFromZipCode(zipCode)),
  resetAddressError: () => dispatch(resetAddressError()),
  updateCustomerProfile: (body) => {
    dispatch(updateCustomerProfile(body));
  },
  saveShippingAddress: (body) => {
    dispatch(updateShippingAddress(body));
  },
  validateShippingAddress: (body, analyticsContext) => {
    dispatch(validateShippingAddress(body, analyticsContext));
  },
});

const ShippingAddressForm = connect(mapStateToProps, mapDispatchToProps)(Form);
export default ShippingAddressForm;
